import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { LaddaModule } from "angular2-ladda";
import { SwitchModule } from "../switch/switch.module";
import {
  FormTemplateComponent,
  ActiveControlFocus
} from "./form-template.component";

@NgModule({
  imports: [CommonModule, FormsModule, SwitchModule, LaddaModule],
  declarations: [FormTemplateComponent, ActiveControlFocus],
  exports: [FormTemplateComponent, ActiveControlFocus]
})
export class FormTemplateModule {}
